export function Drag(el,scale, fun, dragStartFun, dragEndFun) {
  if (el.style.position !== 'absolute') {
    el.style.position = 'absolute'
  }

  function drag(ev) {
    ev = ev || window.event
    ev.stopPropagation()

    const left = Math.round((ev.clientX - el.offset_x)/scale)
    const top = Math.round((ev.clientY - el.offset_y)/scale)
    fun && fun(left, top)
  }

  function dragend() {
    document.removeEventListener('mouseup', dragend)
    document.removeEventListener('mousemove', drag)
    dragEndFun && dragEndFun()
  }

  function dragstart(ev) {
    ev = ev || window.event
    ev.stopPropagation()

    el.offset_x = ev.clientX - el.offsetLeft*scale
    el.offset_y = ev.clientY - el.offsetTop*scale
    document.addEventListener('mouseup', dragend)
    document.addEventListener('mousemove', drag)
    dragStartFun && dragStartFun()
    return false
  }

  el.onmousedown = dragstart
}
